<template>
  <div class="md-layout">
    <!-- <div class="md-layout-item md-size-35"></div> -->
    <div
      class="md-layout-item md-size-25"
      style="
        display: block;
        margin-left: auto;
        margin-right: auto;
        text-align: center;
      "
    >
      <form @submit.prevent="onSubmit()">
        <lable>
          <b
            >Please enter your Mobile No, Email Id and Aadhaar No to view your
            call letter
          </b>
        </lable>
        <md-field>
          <label for="post">post</label>
          <md-select v-model="post" required name="post" id="post">
            <md-option
              v-for="item in postOption"
              v-bind:key="item.key"
              :value="item.key"
            >
              {{ item.value }}
            </md-option>
          </md-select>
        </md-field>
        <md-field>
          <label>Mobile No</label>
          <md-input type="number" v-model="mobileNo" required> </md-input>
        </md-field>
        <md-field>
          <label>Email Id</label>
          <md-input type="email" v-model="email" required> </md-input>
        </md-field>
        <md-field>
          <label>Aadhaar Number (Format 1234 5678 9012)</label>
          <md-input type="text" v-model="aadhar" required> </md-input>
        </md-field>
        <md-button class="md-success" @click="onSubmit()">Submit</md-button>
      </form>
      <div v-if="nodata">
        <br /><br /><br />
        <label>No record found.</label>
        <h5>
          If you have have recived mail regarding call letter, please contact us
          through email with the Mobile number, Email Id and Aadhaar number
          entered in the application.
        </h5>
      </div>
      <div v-if="alldoc.length > 0">
        <br /><br /><br />
        <label>Found multiple applications</label>
        <div>
          <md-button
            class="md-success"
            v-for="(item, index) in alldoc"
            :key="index"
            @click="
              selectdoc(index);
              nodata = false;
            "
          >
            {{ "Call Letter " + (index + 1) }}
          </md-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import { db, applicationsCollection, departmentsCollection } from "@/firebase";
import { db } from "@/firebase";
export default {
  data() {
    return {
      mobileNo: null,
      alldoc: [],
      nodata: false,
      email: null,
      aadhar: "",
      link: null,
      applicationId: "",
      post: "",
      postOption: [
        { value: "Technician (Civil) ", key: "TECCI" },
        { value: "Technician (Tyre) ", key: "TECTY" },
        { value: "Technician (Boiler) ", key: "TECBO" },
        { value: "Technician (Refrigeration) ", key: "TECRF" },
        { value: "Technician (Stores) ", key: "TECST" },
        { value: "Technician (Electrical) ", key: "TECEL" },
        { value: "Technician (Operation) ", key: "TECOP" },
        { value: "Technician (Auto Mechanic) ", key: "TECAM" },
        { value: "Technician (Lab) ", key: "TECLA" },
        { value: "Light Vehicle Driver ", key: "LIVDR" },
        { value: "Heavy Vehicle Driver ", key: "HEVDR" }
      ]
    };
  },
  methods: {
    onSubmit() {
      this.nodata = false;
      this.alldoc = [];
      if (this.mobileNo && this.email && this.aadhar) {
        console.log("entered", this.mobileNo);
        // let self = this;
        db.collection("applications")
          .where("post", "==", this.post)
          .where("mobile", "==", this.mobileNo)
          .where("email", "==", this.email)
          .where("aadhar", "==", this.aadhar)
          .where("razerpay", "!=", null)
          .get()
          .then(querySnapshot => {
            let data = querySnapshot.docs.map(doc => doc.data().callLetterLink);
            let filteredData = data.filter(doc => doc);
            if (filteredData.length == 0) {
              this.nodata = true;
            } else {
              window.location.href = filteredData[0];
            }
            // if (querySnapshot.docs.length > 1) {
            //   // let temparr = [];
            //   let finaldoc = [];
            //   for (let i = 0; i < querySnapshot.docs.length; i++) {
            //     let doc = querySnapshot.docs[i].data();
            //     if (doc.callLetterLink) {
            //       finaldoc.push(doc.callLetterLink);
            //     }
            //   }
            //   if (finaldoc.length > 0) {
            //     console.log(finaldoc[0]);
            //     // window.location.href = finaldoc[0];
            //   }
            // } else if (querySnapshot.docs.length == 1) {
            //   let doc = querySnapshot.docs[0].data();
            //   if (doc.callLetterLink) {
            //     //Todo send to link
            //     window.location.href = doc.callLetterLink;
            //   } else {
            //     this.nodata = true;
            //   }
            // } else {
            //   this.nodata = true;
            // }
          })
          .catch(function(error) {
            console.error("Error getting document:", error);
          });
      }
    },
    selectdoc(index) {
      let doc = this.alldoc[index];
      window.location.href = doc;
    }
  },
  created: function() {
    const container = document.querySelector(".main-panel");
    container.scrollTop = 0;
  }
};
</script>
